'use client';

import { useRef, useCallback } from 'react';
import { FaPhoneAlt } from 'react-icons/fa';

// import
import BeatLoader from '@src/components/atoms/beat-loader';

// Assets
import IArrowRight1 from '@public/svg/i-arrow-right';
import { FiPhone, FiMapPin } from 'react-icons/fi';
import { GoDotFill, GoArrowRight } from 'react-icons/go';
import { FaMapMarkerAlt } from 'react-icons/fa';

const searchTypeText = {
  jual: {
    placeholder:
      'Cari berdasarkan area atau kota. Pilih dari daftar yang muncul.',
    loading: 'Sedang mencari lokasi...',
    notFound:
      'Lokasi tidak ditemukan. Coba ketik area/kota lain atau gunakan kata kunci.',
  },
  sewa: {
    placeholder:
      'Cari berdasarkan area atau kota. Pilih dari daftar yang muncul.',
    loading: 'Sedang mencari lokasi...',
    notFound:
      'Lokasi tidak ditemukan. Coba ketik area/kota lain atau gunakan kata kunci.',
  },
  agent: {
    placeholder:
      'Cari berdasarkan nama, nomor telepon, no. registrasi. Pilih dari daftar yang muncul.',
    loading: 'Sedang mencari marketing...',
    notFound:
      'Marketing tidak ditemukan. Cek kembali kata kunci yang dimasukkan.',
  },
  kantor: {
    placeholder: 'Nama kantor, kota, area',
    loading: 'Sedang mencari kantor...',
    notFound: 'Kantor tidak ditemukan. Cek kembali kata kunci yang dimasukkan.',
  },
};

const ModalSearchDekstop = ({
  showSearch,
  displaySearch,
  listLocation,
  lastItemRef,
  isFetching,
  handleSelectLocation,
  highlightText,
  searchType,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
}) => {
  const scrollContainerRef = useRef(null);

  const handleScroll = useCallback(() => {
    if (!scrollContainerRef.current || isFetchingNextPage || !hasNextPage)
      return;

    const { scrollTop, scrollHeight, clientHeight } =
      scrollContainerRef.current;
    // Trigger when user scrolls to 80% of the content
    if (scrollTop + clientHeight >= scrollHeight * 0.8) {
      fetchNextPage();
    }
  }, [isFetchingNextPage, hasNextPage, fetchNextPage]);

  if (!showSearch) return null;
  return (
    <div
      ref={scrollContainerRef}
      onScroll={handleScroll}
      className="max-h-[383px] overflow-y-auto absolute top-[55px] z-10 left-0 right-0 rounded-[2px] bg-[#fafafa] shadow-[0_2px_24px_0_rgba(4,7,4,0.08)] 
            dd2-xl:hidden"
    >
      <p className="font-satoshi text-[11px] leading-[15.6px] tracking-[-0.11px] text-[#686A68] p-4">
        {searchTypeText[searchType].placeholder}
      </p>

      {!!displaySearch && (
        <div>
          {/* List */}
          {listLocation &&
            listLocation.length > 0 &&
            listLocation.map((item, idx) => (
              <button
                ref={idx === listLocation.length - 1 ? lastItemRef : null}
                key={`${item.id}-${idx}`}
                className={`w-full font-satoshi flex items-center justify-between p-4 text-[17px] border-b-[1px] border-dashed border-[#E6E7E8] hover:bg-[#ffffff] ${
                  searchType === 'agent' || searchType === 'kantor'
                    ? 'items-start'
                    : ''
                }`}
                onClick={() => handleSelectLocation(item)}
              >
                {searchType === 'agent' ? (
                  <div className="flex flex-col items-start gap-1 flex-1">
                    <h3 className="font-satoshi-bold text-[17px]/[23.8px] mb-1 tracking-[0.17px] text-[#040704]">
                      {highlightText(item.full_name, displaySearch)}
                    </h3>
                    <div className="flex items-center gap-2">
                      <div className="flex items-center gap-1">
                        <FaPhoneAlt className="text-[14px] text-[#252526]" />
                        <span className="text-[14px]/[19.6px] text-[#686A68]">
                          {item.phone || '-'}
                        </span>
                      </div>
                      <GoDotFill className="text-base text-[#DEDFDE]" />
                      <span className="text-[14px]/[19.6px] text-[#686A68]">
                        {item.office || '-'}
                      </span>
                    </div>
                  </div>
                ) : searchType === 'kantor' ? (
                  <div className="flex flex-col items-start gap-1 flex-1">
                    <h3 className="font-satoshi-bold text-[17px]/[23.8px] mb-1 tracking-[0.17px] text-[#040704]">
                      {highlightText(item.name, displaySearch)}
                    </h3>
                    <div className="flex items-start gap-1">
                      <FaMapMarkerAlt size={16} className="text-[#252526] mt-0.5" />
                      <div>
                        <p className="text-[14px]/[19.6px] text-[#686A68] text-start">
                          {item.city || '-'}, {item.area || '-'}
                        </p>
                        {item.address && (
                          <p className="text-[11px]/[15.4px] text-[#686A68] text-start">
                            {item.address}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  highlightText(item.name, displaySearch)
                )}

                <div className="flex items-center gap-2">
                  <p className="bg-[#EBF0F7] rounded-[4px] px-2 font-satoshi text-[11px]/[15.6px] tracking-[0.11px] text-[#3268AE]">
                    {searchType === 'agent' ? `#${item.id}` : item.slug}
                  </p>
                  <div className="w-4 h-4 bg-[#F5F5F5] rounded-[4px] p-1 flex items-center justify-center">
                    <GoArrowRight className="text-base text-[#686A68]" />
                  </div>
                </div>
              </button>
            ))}

          {/* Fallback kata kunci - hanya tampil jika tidak ada hasil dan tidak loading */}
          {!listLocation?.length && !isFetching && (
            <div
              onClick={() =>
                handleSelectLocation({
                  name: displaySearch,
                  slug: 'kata-kunci',
                })
              }
              className="flex items-center justify-between gap-2 p-4 border-b-[1px] border-dashed border-[#DEDFDE] cursor-pointer hover:bg-[#ffffff]"
            >
              <p className="font-satoshi text-[17px]/[23.8px] tracking-[0.17px] text-[#040704]">
                {displaySearch}
              </p>

              <div className="flex items-center gap-2">
                <p className="bg-[#EBF0F7] rounded-[4px] px-2 font-satoshi text-[11px]/[15.6px] tracking-[0.11px] text-[#3268AE]">
                  Kata Kunci
                </p>
                <div className="w-4 h-4 bg-[#F5F5F5] rounded-[4px] p-1 flex items-center justify-center">
                  <IArrowRight1 color="#686A68" width={8} height={8} />
                </div>
              </div>
            </div>
          )}

          {/* Loader */}
          {isFetching && (
            <div className="flex items-center gap-2 justify-between p-4">
              <p className="font-satoshi text-[14px]/[19.6px] text-[#040704]">
                {searchTypeText[searchType].loading}
              </p>
              <BeatLoader />
            </div>
          )}

          {/* No results state */}
          {!isFetching && listLocation?.length === 0 && (
            <div className="flex items-center gap-2 justify-between p-4">
              <p className="font-satoshi text-[14px]/[19.6px] text-[#040704]">
                {searchTypeText[searchType].notFound}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ModalSearchDekstop;
